import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { ToasterService } from 'angular2-toaster';
import 'rxjs/add/operator/toPromise';

import { SalesBillentryModel } from '../model/index';

@Injectable()
export class SalesBillentryService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private salesBillentryUrl = 'api/salesBillentry';  // URL to web api

    constructor(private http: Http, public toasterService: ToasterService) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getSalesbillentryList(query: any): Promise<SalesBillentryModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesBillentryUrl}/getSalesbillentryList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getSpareBillPrintData(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.salesBillentryUrl}/getSpareBillPrintData`, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getSalesbillentryDetailList(query: any): Promise<SalesBillentryModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesBillentryUrl}/getSalesbillentryDetailList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData,
                // Errors will call this callback instead:
                err => {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Something went wrong, Please Contact System Admin'
                    };
                    this.toasterService.pop(toast);
                })
            .catch(this.handleError);
    }

    addSalesBillentry(query: any): Promise<SalesBillentryModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesBillentryUrl}/addSalesBillentry`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteGridList(rowData: any): Promise<SalesBillentryModel> {
        const url = `${this.salesBillentryUrl}/deleteGridList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as SalesBillentryModel)
            .catch(this.handleError);
    }

    /*  getTestingbill(client_id: number): Promise<SalesBillentryModel> {
          const url = `${this.salesBillentryUrl}/clientList?client_id=${client_id}`;
          return this.http.get(url)
              .toPromise()
              .then(response => response.json().data as SalesBillentryModel)
              .catch(this.handleError);
      }
  */
    /*   getTestingbillClientList(): Promise<any> {
           const url = `${this.salesBillentryUrl}/getTestingbillClientList`;
           return this.http.get(url)
               .toPromise()
               .then(this.extractData)
               .catch(this.handleError);
       }*/

    /* getTestingtypeList(): Promise<any> {
         const url = `${this.salesBillentryUrl}/getTestingtypeList`;
         return this.http.get(url)
             .toPromise()
             .then(this.extractData)
             .catch(this.handleError);
     }*/

    deleteSalesBillentry(rowData: any): Promise<SalesBillentryModel> {
        const url = `${this.salesBillentryUrl}/deleteSalesBillentry`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as SalesBillentryModel)
            .catch(this.handleError);
    }

    addUpdatesalesBillentry(data: any): Promise<SalesBillentryModel> {

        const url = `${this.salesBillentryUrl}/addUpdatesalesBillentry`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as SalesBillentryModel)
            .catch(this.handleError);
    }

    getExistAdvClient(data: any): Promise<SalesBillentryModel[]> {
        // let params: URLSearchParams = new URLSearchParams();
        // for (let key in query) {
        //     params.set(key.toString(), query[key]);
        // }
        //
        // let options = new RequestOptions({
        //     headers: this.headers,
        //     search: params
        // });
        //
        // const url = `${this.salesBillentryUrl}/getExistAdvClient`;
        // return this.http.get(url, options)
        //     .toPromise()
        //     .then(this.extractData)
        //     .catch(this.handleError);

        const url = `${this.salesBillentryUrl}/getExistAdvClient`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    addEmiGridDetails(query: any): Promise<SalesBillentryModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesBillentryUrl}/addEmiGridDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteEmiList(rowData: any): Promise<SalesBillentryModel> {
        const url = `${this.salesBillentryUrl}/deleteEmiList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as SalesBillentryModel)
            .catch(this.handleError);
    }

    getChalloutModel(query: any): Promise<SalesBillentryModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesBillentryUrl}/getChalloutModel`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getExistChalloutClient(query: any): Promise<SalesBillentryModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesBillentryUrl}/getExistChalloutClient`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPendingSalesReturnBills(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesBillentryUrl}/getPendingSalesReturnBills`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getClientPointsForRedemption(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.salesBillentryUrl}/getClientPointsForRedemption`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    generateClientOtp(data: any): Promise<any> {
        const url = `${this.salesBillentryUrl}/generateClientOtp`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    verifyClientOtp(data: any): Promise<any> {
        const url = `${this.salesBillentryUrl}/verifyClientOtp`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    generateCouponOtp(data: any): Promise<any> {
        const url = `${this.salesBillentryUrl}/generateCouponOtp`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    verifyCouponOtp(data: any): Promise<any> {
        const url = `${this.salesBillentryUrl}/verifyCouponOtp`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    validateCouponCode(data: any): Promise<any> {
        const url = `${this.salesBillentryUrl}/validateCouponCode`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/salesBillentry.service.ts